import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogHeader, DialogTitle, DialogBody, DialogFooter } from "../../Shared/Dialog";
import Button from "../../Shared/Buttons/Button";
import Input from "../../Shared/Input";
import Label from "../../Shared/Label";
import { dataService } from "../../../Services/data/data.service";
import { toast } from "react-toastify";
import FlowBoxPairingGuide from "./FlowBoxPairingGuide";
import { flowBoxErrorMessage } from "./flowBoxErrors";

function AssignFlowBoxImeiDialog({ open, onClose, onAssigned, userId, device }) {
  const { t } = useTranslation();
  const [imei, setImei] = useState("");
  const [imeiError, setImeiError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setImei("");
    setImeiError("");
  }, [open]);

  const handleClose = () => {
    setImei("");
    setImeiError("");
    onClose();
  };

  const handleSubmit = () => {
    if (!imei.trim()) {
      setImeiError(t("flowBox.assignImei.imeiRequired"));
      return;
    }

    setLoading(true);
    dataService
      .assignImeiToPendingDevice({
        pendingDeviceId: device.id,
        imei: imei.trim(),
        updatedByUserId: userId,
      })
      .then(() => {
        handleClose();
        toast.success(t("flowBox.assignImei.assignedSuccess"));
        onAssigned();
      })
      .catch((err) => toast.error(flowBoxErrorMessage(err, t, "flowBox.assignImei.assignFailed")))
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs">
      <DialogHeader>
        <DialogTitle>{t("flowBox.assignImei.title")}</DialogTitle>
      </DialogHeader>
      <DialogBody>
        <p style={{ margin: "0 0 12px", fontSize: 14, fontFamily: "Lato, sans-serif", color: "#6b7280" }}>
          {t("flowBox.assignImei.description", { name: device?.displayName || t("flowBox.card.unnamed") })}
        </p>
        <div className="dialog-field">
          <Label htmlFor="assignImei" errorText={imeiError} required>
            {t("flowBox.register.imeiLabel")}
          </Label>
          <Input
            name="assignImei"
            value={imei}
            onChange={(e) => { setImei(e.target.value); setImeiError(""); }}
            placeholder={t("flowBox.register.imeiPlaceholder")}
            error={!!imeiError}
            fullwidth
            autoFocus
            inputProps={{ maxLength: 15 }}
          />
        </div>
        <div style={{ marginTop: 12 }}>
          <FlowBoxPairingGuide buttonCount={device?.buttonCount || 5} />
        </div>
      </DialogBody>
      <DialogFooter>
        <Button variant="light" onClick={handleClose}>{t("common.cancel")}</Button>
        <Button onClick={handleSubmit} disabled={loading} loading={loading}>
          {t("flowBox.assignImei.assign")}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}

export default AssignFlowBoxImeiDialog;
